import classes from "./Button.module.css";
export const Button = {
  defaultProps: {
    className: classes.button,
  },
};
